import React, { useState } from 'react';
import { string, element } from 'prop-types';
import { Popover, Typography } from '@one-thd/sui-atomic-components';
import WhatToExpect from './WhatToExpect';

const placement = 'bottom-start';
const ProductAddonsTooltip = React.forwardRef(({ tooltipContent, title, label }, buttonRef) => {

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? `${placement}-popover` : undefined;

  return (
    <>
      <Popover
        open={open}
        id={id}
        anchorEl={anchorEl}
        placement={placement}
        title={title}
        onClose={handleClose}
      >
        <Typography variant="body-base">
          {tooltipContent}
        </Typography>
      </Popover>
      <WhatToExpect
        onClick={handleClick}
        ref={buttonRef}
        label={label}
      />
    </>
  );
});

ProductAddonsTooltip.displayName = 'ProductAddOns-tooltip';

ProductAddonsTooltip.propTypes = {
  title: string,
  tooltipContent: element,
  label: string
};

ProductAddonsTooltip.defaultProps = {
  title: '',
  tooltipContent: null,
  label: ''
};

export { ProductAddonsTooltip };